/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import Modal, { ModalHeader, ModalTab } from '../Modal';
import { editMembershipEnableHistory, getMembershipEnableHistory, getMembershipHistoryDetails, getMemberships } from '../../apis/membership';
import { getParams } from '../../utils/params';
import { MEMBERSHIP_TARGET_TYPE } from '../../constants/MEMBERSHIP';
import { ControlTable } from '../Table';
import { isEmpty } from '../../utils/lodashExtend';
import Form from '../Form';
import { isNumber } from '../../utils/number';
import { toast } from '../../utils/toast';
import ToolTip from '../ToolTip/ToolTip';
/**
  * 회사별 상세 멤버십
  * 과거이력 확인 및 변경가능하도록
  */

const defaultForm = {};
const MembershipHistory = ({ open, setOpen, companyIdx, submit }) => {
  const [fields, setFields] = useState([]);
  const [tableFields] = useState([
    { title: "멤버십 등급", key: "membership.label" },
    { title: "멤버십 대상", key: "membership.targetType", onValue: (v) => MEMBERSHIP_TARGET_TYPE.find(f => f.value === v)?.label },
    {
      title: "멤버십 적용여부", key: "membership.isEnable",
      onValue: (v, _f, d) => v
        ? <span className="color-main-100">사용</span>
        : <span className="error">미적용</span>
    },
    {
      title: "메모", key: "memo", onValue: (d) => {
        return (
          <>
            <span>{d?.length > 10 ? `${d?.slice(0, 10)}.. ` : d || '-'}</span>
            {d?.length > 10 && <ToolTip tooltiptext={d} position="bottom" />}
          </>
        );
      }
    },
    { title: "적용자", key: "employee", onValue: (v) => v.company.type === 9 ? "wecake" : v.name },
    { title: "적용일", key: "cratedTime", type: "datetime" },

  ]);

  const [memberships, setMemberships] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const tabList = [
    { label: "멤버십 정보", action: setActiveTab },
    { label: "멤버십 변경이력", action: setActiveTab },
  ];

  useEffect(() => {
    if (!isEmpty(memberships)) {
      const _fields = [
        {
          type: "select",
          title: "멤버십등급",
          options: {
            list: memberships
          },
          key: "membershipIdx"
        },
        {
          title: "메모",
          type: "textarea",
          key: "memo",

        }
      ];
      setFields(_fields);
    }
  }, [memberships]);

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    submit && submit();
    setActiveTab(0);
  };

  const _submit = (_form) => {
    const params = {
      memo: _form.memo,
      membershipIdx: +_form.membershipIdx,
      companyIdx,
    };

    editMembershipEnableHistory(originForm.idx, params)
      .then(res => {
        toast.success("변경되었습니다.");
        close();
      });
  };

  const {
    form,
    originForm,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
    fields
  );

  const {
    form: listForm,
    setSubmit,
    list, setList,
    isLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setIsLoading,
  } = useForm({
    limit: 10,
    offset: 0,
    order: [{ createdTime: "desc" }]
  });

  const _listSubmit = (form) => {
    getMembershipHistoryDetails(companyIdx, getParams(form))
      .then(res => {
        const { rows = [], count = 0 } = res;
        setList(rows);
        setTotal(count);
      })
      .finally(setIsLoading(false));
  };



  useEffect(() => {
    if (isNumber(companyIdx)) {
      getMembershipEnableHistory(companyIdx).then(res => {
        setForm(res);
        setOriginForm(res);
      });
      _listSubmit(listForm);
      setSubmit(_listSubmit);

      getMemberships({})
        .then(res => {
          setMemberships(res.rows.map(item => ({ ...item, value: item.idx })));
        });
    }
  }, [open, companyIdx]);


  const isDisabledSubmit = () => {
    return !(+form.membershipIdx !== +originForm.membershipIdx || form.memo !== originForm.memo);
  };
  return (
    <>

      <Modal
        isOpen={open && isNumber(companyIdx)}
        close={close}
      >
        <ModalHeader>
          {`"${form?.company?.name}" 멤버십 설정정보`}
        </ModalHeader>
        <div className="care-company-addsiteinfo">
          <div className="header-wrap pb-12">
            <ul className="header-tab">
              <li className="header-item">{form?.managerCompany?.name && (
                <span className="">
                  {`관리회사: ${form?.managerCompany?.name}`}
                </span>
              )}</li>
            </ul>
          </div>

        </div>
        <ModalTab tabList={tabList} active={activeTab} />

        {activeTab === 0 && (
          <Form
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
            submit={handleSubmit}
            submitText={"변경"}
            cancel={close}
            isDisabledSubmit={isDisabledSubmit}

          />
        )}
        {activeTab === 1 && (
          <ControlTable
            isHideControlHeader
            fields={tableFields}
            list={list}
            isLoading={isLoading}
            total={total}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            isControl={false}
          />
        )}

      </Modal>
    </>
  );
};

export default MembershipHistory;